import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getInitialLang } from "./Init.jsx";

const LanguageRedirect = () => {
  const navigate = useNavigate();
  const where = getInitialLang();

  useEffect(() => {
    navigate(`/${where}`);
  }, [navigate]);

  return null;
};

export default LanguageRedirect;
